import type { IntlShape } from 'react-intl';
import type { SubscriptionFeature } from '@alltrails/types/SubscriptionFeature';
import routeAssistantSrc from './images/route-assistant-thumb.avif';

const routeAssistant = (intl: IntlShape): SubscriptionFeature => ({
  headline: intl.formatMessage({ defaultMessage: 'Route Assistant' }),
  subheadline: intl.formatMessage({ defaultMessage: 'Plan backpacking trips effortlessly with our built-in assistant' }),
  thumbnailImage: routeAssistantSrc.src
});

export default routeAssistant;
